import { render } from "./2022-10-11-Triangle.md?vue&type=template&id=675392f8"
const script = {}

import "./2022-10-11-Triangle.md?vue&type=style&index=0&id=675392f8&lang=css"
script.render = render

export default script